import * as Yup from "yup";

export const validationSchema = Yup.object().shape({
  unit: Yup.string().required("Unit is required"),
  nurse: Yup.string().required("Nurse is required"),
  facility: Yup.string().required("Facility is required"),
  formQuestions: Yup.object().shape({
    healthCareWorker: Yup.string()
      .oneOf(
        [
          "Physician",
          "Registered Staff",
          "PSW",
          "Student",
          "Dietary",
          "Social worker",
          "Pastoral care",
          "Lab/X-ray/blood collection",
          "OT/PT/PTA (Therapy Staff)",
          "Housekeeping",
          "Laundry staff",
          "Volunteer",
          "Programs",
          "Essential Caregiver",
          "Private caregiver",
          "One-to-one worker",
          "Dental services",
          "BSO",
          "Optometry",
          "Hair Stylist",
          "Nurse Practitioner",
          "General visitor",
          "Footcare nurse",
          "Admin",
          "Security",
          "Maintenance",
        ],
        "Invalid Health Care Worker"
      )
      .required("Health Care Worker is required"),
    handHygieneMoment: Yup.string()
      .oneOf(
        [
          "BEF-PAT/ENV",
          "BEF-ASP",
          "AFT-BFL",
          "AFT-PAT/ENV",
          "BEF Nurse Med Pass",
          "AFT Nurse Med Pass",
          "BEF Resident Meal-time",
          "Resident Nourishment Pass",
          "General",
        ],
        "Invalid Hand Hygiene Moment"
      )
      .required("Hand Hygiene Moment is required"),
    outcome: Yup.string()
      .oneOf(["wash", "rub", "missed"], "Invalid Outcome")
      .required("Outcome is required"),
    timer: Yup.number().when("outcome", {
      is: (val) => ["wash", "rub"].includes(val),
      then: Yup.number()
        .min(1, "Timer must be greater than 0 for Wash or Rub")
        .required("Timer is required for Wash or Rub"),
    }),
    custom: Yup.object().shape({
      rings: Yup.boolean(),
      gloves: Yup.boolean(),
      nails: Yup.boolean(),
      bracelet: Yup.boolean(),
    }),
    comment: Yup.string(),
  }),
  isTimerRunning: Yup.boolean().test(
    "additional-field-validation",
    "Timer is running",
    function (value) {
      return !value; // Return true if validation passes (additionalField is false)
    }
  ),
});
